/**
 * 判断是否开启了全局配置
 * @returns
 */
export function isUseGlobalConfig() {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.__cn_address_global_props__) === null || _a === void 0 ? void 0 : _a.forceUseGlobalConfig)
        return true;
    return false;
}
